import { callFunction } from '../utils/apiClient';

/** Generate + assign the user's own profile picture (charges credits). Returns the new photo URL. */
export const generateProfileAvatar = (prompt?: string) =>
  callFunction<{ photoUrl: string }>('generateProfileAvatar', { prompt });

/** Revert a custom avatar back to the social sign-in photo (or initials). No charge. */
export const resetProfileAvatar = () =>
  callFunction<{ cleared: boolean }>('resetProfileAvatar', {});

/**
 * "About you" — OPTIONAL self-info (gender, DOB + star sign, hobbies, sports, location, favourite
 * food, pet, favourite song/movie, short bio) the agent cast references warmly to feel personal.
 * All fields optional; star_sign auto-derives from DOB server-side.
 */
export interface AboutYou {
  gender?: string;
  dob?: string;
  star_sign?: string;
  location?: string;
  hobbies?: string;
  sports?: string;
  favourite_food?: string;
  pets?: string;
  favourite_song?: string;
  favourite_movie?: string;
  bio?: string;
  /** Who you're drawn to — flavors a light, non-sexual bond warmth. 'none' keeps agents strictly platonic. */
  attracted_to?: 'women' | 'men' | 'everyone' | 'none';
}

export const getMyAboutYou = () =>
  callFunction<{ about_you: AboutYou }>('getMyAboutYou', {}).then((r) => r.about_you || {});

export const updateMyAboutYou = (patch: AboutYou) =>
  callFunction<{ about_you: AboutYou }>('updateMyAboutYou', patch).then((r) => r.about_you || {});
